module.exports = __webpack_public_path__ + "static/media/no-results.8be5c541.png";